import { createContext, useContext, useState, type ReactNode } from 'react'

interface ShareBookingLinkContextType {
  showShareBookingLinkDialog: boolean
  openShareBookingLinkDialog: () => void
  closeShareBookingLinkDialog: () => void
}

const ShareBookingLinkContext = createContext<ShareBookingLinkContextType | undefined>(undefined)

export function ShareBookingLinkProvider({ children }: { children: ReactNode }) {
  const [showShareBookingLinkDialog, setShowShareBookingLinkDialog] = useState(false)

  const openShareBookingLinkDialog = () => {
    setShowShareBookingLinkDialog(true)
  }

  const closeShareBookingLinkDialog = () => {
    setShowShareBookingLinkDialog(false)
  }

  return (
    <ShareBookingLinkContext.Provider value={{
      showShareBookingLinkDialog,
      openShareBookingLinkDialog,
      closeShareBookingLinkDialog,
    }}>
      {children}
    </ShareBookingLinkContext.Provider>
  )
}

export function useShareBookingLinkContext() {
  const context = useContext(ShareBookingLinkContext)
  if (context === undefined) {
    throw new Error('useShareBookingLinkContext must be used within ShareBookingLinkProvider')
  }
  return context
}
